// START_MODULE pages_main_sections_description_styled_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled from 'styled-components';

import { ContentSectionContainer } from 'components/layout/contentSectionContainer/ContentSectionContainer';

export const ContentSectionContainerCustom = styled(ContentSectionContainer)`
  background-color: #eaeaea;
  border-radius: 0 0 217px 217px / 0 0 29px 29px;
`;

export const DescriptionContentInnerWrapper = styled.div`
  display: flex;
  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }

  p {
    margin-bottom: 12px;
    font-family: "Montserrat", Arial, serif;
  }
`;

export const DescriptionImage = styled.img`
  max-height: 300px;
  object-fit: cover;
`;

// END_MODULE pages_main_sections_description_styled_ts
